<template>
  <div class="history-table">
    <table class="table">
      <thead class="t-header">
        <tr class="row">
          <template v-for="(item, index) in headerNameList">
            <th
              :key="`th${index}`"
              class="th"
              :style="{ width: headerWidthList[index] }"
            >
              <span class="val">{{ item }}</span>
            </th>
          </template>
        </tr>
      </thead>
      <tbody class="t-body">
        <template v-for="(item, index2) in historyList">
          <tr :key="`tr${index2}`" class="row">
            <!-- buyDateのセル（isHistoryがtrueの場合のみrowspanを適用） -->
            <td
              v-if="
                isHistory &&
                  buyDateRowspan[item.buyDate] &&
                  buyDateRowspan[item.buyDate].firstIndex === index2
              "
              :rowspan="isHistory ? buyDateRowspan[item.buyDate].count : 1"
              class="td"
              :style="{ width: headerWidthList[0] }"
            >
              <span class="val">{{ item.buyDate }}</span>
            </td>

            <!-- buyDate以外のセル -->
            <td
              v-for="(dispKey, index) in isHistory
                ? dispKeyList.slice(1)
                : dispKeyList"
              :key="`td${index}`"
              class="td"
              :style="{ width: headerWidthList[index + 1] }"
              :class="{
                usePoint: dispKey === 'usePoint',
                bonusPoint: dispKey === 'bonusPoint',
              }"
              @click="handleClick(dispKey, item)"
            >
              <!-- bonusPoint のとき -->
              <div v-if="dispKey === 'bonusPoint'" class="bonusPoint">
                <div class="flex">
                  <img src="/img/star_coin.webp" alt="" />
                  <span class="val" v-html="item[dispKey]"></span>
                </div>
              </div>

              <!-- appraisedAmount のとき -->
              <div v-else-if="dispKey === 'appraisedAmount'" class="appraisedAmount">
                <div class="flex">
                  <span class="val">&yen;{{ item[dispKey] | comma }}-</span>
                </div>
              </div>

              <!-- usePoint のとき -->
              <div v-else-if="dispKey === 'usePoint'" class="usePoint">
                <span class="val" v-html="item[dispKey]"></span>
                <img class="usePoint_img" src="/img/menu_right.png" alt="" />
              </div>

              <!-- totalAmount のとき -->
              <div v-else-if="dispKey === 'totalAmount'" class="totalAmount">
                <span class="val" v-html="item[dispKey]"></span>
                <img class="usePoint_img" src="/img/menu_right.png" alt="" />
              </div>

              <!-- detail のとき -->
              <div v-else-if="dispKey === 'detail'">
                <BuyButton
                  :isArrow="false"
                  :text="t('詳細へ')"
                  class="purchase-btn"
                  @handleSquareBtnClick="$emit('handleClick', dispKey, item)"
                />
              </div>

              <!-- それ以外（memo, money など） -->
              <div v-else>
                <span class="val" v-html="item[dispKey]"></span>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import t from '@/plugins/i18n';
import BuyButton from '@/components/atoms/BuyButton.vue';
import { separateCharacterNumber } from '@/common/util/format';

export default {
  name: 'HistoryTable',
  mixins: [t],

  components: {
    BuyButton,
  },

  props: {
    historyList: {
      type: Array,
      default: () => [],
    },
    headerNameList: {
      type: Array,
      default: () => [],
    },
    headerWidthList: {
      type: Array,
      default: () => [],
    },
    dispKeyList: {
      type: Array,
      default: () => [],
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  computed: {
    // rowspanのために各buyDateの出現回数と最初のindexを記録
    buyDateRowspan() {
      if (!this.isHistory) return {}; // isHistoryがfalseなら処理不要

      const rowspanMap = {};

      this.historyList.forEach((item, index) => {
        if (!rowspanMap[item.buyDate]) {
          rowspanMap[item.buyDate] = { count: 1, firstIndex: index };
        } else {
          rowspanMap[item.buyDate].count += 1;
        }
      });

      return rowspanMap;
    },
  },

  methods: {
    handleClick(key, item) {
      this.$emit('handleClick', key, item);
    },
  },
};
</script>

<style lang="scss" scoped>
.history-table {
  color: $gray2;
  font-weight: bold;
  margin-top: 30px;
}
.table {
  width: 100%;
  min-width: var(--table-min-width);
  background-color: #fff;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 11px;
  border: none;
}
.t-header {
  display: table-header-group;
  background-color: #fff;
}
.t-header .row {
  display: table-row;
  border-bottom: 1px solid #e0e0e0;
}
.t-header .th {
  color: #464646;
  line-height: 1.1;
  padding: 10px 3px;
  vertical-align: middle;
  text-align: center;
  border-right: 1px solid #E0E0E0;
  height: 50px;
}
.t-header .th:last-child {
  border-right: none;
}
.t-header .val {
  background: linear-gradient(to bottom, #5eb3cf, #276bad);
  color: $white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 2px;
  height: 100%;
  min-height: 30px;
}
.t-body {
  display: table-row-group;
}
.t-body .row {
  display: table-row;
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
}
.t-body .td {
  display: table-cell;
  padding: 10px 16px;
  text-align: center;
  vertical-align: middle;
  word-break: break-word;
  border-right: 1px solid #e0e0e0;
  line-height: normal !important;
}
.t-body .td:last-child {
  border-right: none;
}
.t-body .td .val {
  font-size: 14px;
  text-align: center;
}

.bonusPoint {
  width: 100% !important;
  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 35px;
    }
  }
}
.usePoint {
  width: 100% !important;
  display: flex !important;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.usePoint_img {
  width: 25px;
}
.totalAmount {
  width: 100% !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  .val {
    text-align: center;
    flex: 1;
  }
  .usePoint_img {
    position: absolute;
    right: 0;
  }
}
.purchase-btn {
  white-space: nowrap;
  font-size: 14px;
  padding: 5px 10px;
  @media screen and (max-width: $tabletWidth) {
    font-size: 8px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .history-table {
    margin-top: 20px;
  }
  .table {
    font-size: 10px;
  }
  .t-header .th {
    padding: 5px 3px;
    height: 40px;
  }
  .t-body .td {
    padding: 5px 3px;
  }
  .t-body .td .val {
    font-size: 11px;
  }

  .bonusPoint {
    .flex {
      img {
        width: 20px;
      }
    }
  }
  .usePoint_img {
    width: 15px;
    right: -7px !important;
  }
}
</style>
